import { render, staticRenderFns } from "./edit_promotion.vue?vue&type=template&id=14a6bac4&scoped=true&"
import script from "./edit_promotion.vue?vue&type=script&lang=js&"
export * from "./edit_promotion.vue?vue&type=script&lang=js&"
import style0 from "./edit_promotion.vue?vue&type=style&index=0&id=14a6bac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a6bac4",
  null
  
)

export default component.exports